import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 动态表单台账微服务方式引入
import "/src/extend/LedgerConfig"

// 引入配置
import { api, title } from './config'

// 引入工具
import JTool from './components/JComponents/JTool'

// 引入ui组件依赖
import ElementUI from 'element-ui'

// sso单点登录
import singleLogin from "./btzh/singleLogin"

// 引入插件拓展
import "./extend/Moment";
import "./extend/Localforage"
import http from "./extend/Axios/http";
import ElUploadExtend from "./extend/ElUpload/ElUploadExtend";
import { $message } from "./extend/ElMessage/ElMessageExtend";

// 全局引入svg组件
import '@/svg';
import JSvgIcon from "./components/JComponents/JSvgIcon/JSvgIcon";

// 全局引入图片预览组件
import "./components/JComponents/JImagePreview/JImagePreview";

// 引入样式集合
import '@/style/theme/light/index.scss'
import '@/style/theme/dark/index.scss'

import '@/extend/Directive/action'

Vue.component('JSvgIcon', JSvgIcon)

Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
Vue.prototype.$message = $message
Vue.component(ElUploadExtend.name, ElUploadExtend)
Vue.use(http, { api })
Vue.use(JTool)

Vue.config.productionTip = false

Vue.store = store
Vue.router = router

Vue.use(singleLogin, async isSingleLogin => {
  let adminJson = window.sessionStorage.getItem('biz_admin')
  if (adminJson) {
    store.commit('user', { isSingleLogin, ...JSON.parse(adminJson || '{}') })
  } else if (!isSingleLogin) {
    router.replace('/login')
  }

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
